__turbopack_context__.v({
  "wrapper": "styles-module__reZSDa__wrapper",
});
